const ComparisonChecklist = () => {
  const checklistItems = [
    {
      category: 'Certifications & Compliance',
      items: [
        'UL certified fireproofing systems and materials',
        'ICC and ASTM compliance certifications',
        'Licensed and bonded fireproofing contractor',
        'OSHA safety training and compliance records'
      ]
    },
    {
      category: 'Experience & Expertise',
      items: [
        'Minimum 10+ years fireproofing experience',
        'Commercial and industrial project portfolio',
        'Expertise in multiple fireproofing systems',
        'Knowledge of local building codes and fire ratings'
      ]
    },
    {
      category: 'Insurance & Warranties',
      items: [
        'Comprehensive general liability insurance',
        'Workers compensation coverage',
        'Written warranty on fireproofing installation',
        'Material manufacturer warranties provided'
      ]
    },
    {
      category: 'Project Management',
      items: [
        'Detailed scope of work and specifications',
        'Transparent pricing with no hidden costs',
        'Clear project timeline and milestones',
        'Quality control and inspection procedures'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Fireproofing Contractor Comparison Checklist
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Use this comprehensive checklist to evaluate and compare fireproofing companies in El Paso, ensuring you hire a certified professional for your fire protection project.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {checklistItems.map((section, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-red-50 rounded-lg p-8"
            >
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-checkbox-circle-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">
                  {section.category}
                </h3>
              </div>
              <ul className="space-y-3">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className="ri-check-line text-red-600 mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-red-600 rounded-lg p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-4">
            Ready to Find Your Fireproofing Contractor?
          </h3>
          <p className="text-lg mb-6 opacity-90">
            Connect with pre-screened, certified fireproofing companies who meet these quality standards
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Free Quotes Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default ComparisonChecklist;
